module.exports = __webpack_public_path__ + "img/art-43.f9aac4e7.png";